import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectErrorState = createFeatureSelector<any>('error');
/**
 * @deprecated
 * Consider to use `ActionTrackerService` instead (recommended)
 */
export const selectError = createSelector(selectErrorState, (entities) => entities);
